import React from 'react';
import { Box, Heading, Flex, IconButton, useColorModeValue, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import ExportScripts from '../components/admin/ExportScripts';

/**
 * Page for managing data exports and running export scripts
 */
const ExportPage = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  
  return (
    <Box minH="100vh" bg={useColorModeValue('gray.50', 'gray.900')}>
      <Flex 
        as="header" 
        position="sticky" 
        top="0" 
        zIndex="1" 
        align="center" 
        p={4} 
        bg={bgColor} 
        borderBottomWidth="1px"
      >
        <IconButton
          as={RouterLink}
          to="/"
          icon={<ArrowBackIcon />}
          variant="ghost"
          mr={4}
          aria-label="Back to Dashboard"
        />
        
        <Breadcrumb>
          <BreadcrumbItem>
            <BreadcrumbLink as={RouterLink} to="/">Dashboard</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>Data Exports</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
      </Flex>
      
      <Box p={4} maxW="1200px" mx="auto">
        <Heading mb={6}>Data Exports</Heading>
        <ExportScripts />
      </Box>
    </Box>
  );
};

export default ExportPage;
